export default {
  "prezzo": {
    title: "Che prezzo inserire per la tua compravendita?",
    content: "Prezzo compravendita"
  },
  "rendita_catastale_5_compreso_primo_garage": {
    title: "Conosci le norme della rendita catastale?",
    content: "La rendita catastale dei beni immobili viene sempre calcolata moltiplicando la consistenza catastale per la tariffa d’estimo. Tale valore è molto importante perché permette di ottenere il valore catastale, ovvero quell’unità numerica che permette di calcolare le imposte."
  },
  "rendita_catastale_5_compreso_secondo_garage": {
    title: "Rendita Catastale la conosci?",
    content: "Rendita catastale rivalutata 5%"
  },
  "applicazione_dl_73_05_2021": {
    title: "Scopri i descreti...",
    content: "Selezionare \"SI\" se il decreto legge n. 73 del 25 maggio 2021 è applicabile: acquirenti meno di 36 anni ed ISEE inferiore a 40.000,00 euro annui (SOLO PRIMA CASA)."
  }
}